// User
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const PROFIL_PICTURE = 'PROFIL_PICTURE'
export const TOKEN = 'TOKEN'

// Advisor
export const SET_AVAILABLE = 'SET_AVAILABLE'

// Client
export const GET_CLIENTS = 'GET_CLIENTS'
export const UPDATE_CLIENT = 'UPDATE_CLIENT'
export const ADD_CLIENT = 'ADD_CLIENT'
export const EDIT_CLIENT = 'EDIT_CLIENT'

// Note
export const ADD_NOTE = 'ADD_NOTE'
export const UPDATE_NOTE = 'UPDATE_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'

// Random
export const FILL_ESTATE = 'FILL_ESTATE'
export const ADD_LCBCFT_TO_CLIENT = 'ADD_LCBCFT_TO_CLIENT'
export const ADD_CHECK_PAYSAGE = 'ADD_CHECK_PAYSAGE'

export const GET_INVESTMENT_STATS = 'GET_INVESTMENT_STATS'



// WEBPACK FOOTER //
// ./src/store/modules/Users/types.js